var _defs, _title, _polygon, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconPark = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "ece071ab-22d2-4dbb-99b6-48ce4cda6e2b",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 1024 1024"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "f804b01f-b289-4ac0-96a9-c0d1eca9c61f"
}, /*#__PURE__*/React.createElement("path", {
  d: "M654.5,720V672.2a14.33,14.33,0,0,0-15.9-15.9h-51l-14.3-51L543,611.7l15.9,60.6V720H479.2V527.1h3.2A63.53,63.53,0,0,0,527,547.8h1.6a38.49,38.49,0,0,0,22.3-4.8,63.58,63.58,0,0,0,39.8-60.6h0v-9.6h0a65.4,65.4,0,0,0-31.9-44.6,46,46,0,0,0,6.4-27.1A54.16,54.16,0,0,0,519,346.9V335.7a54.18,54.18,0,0,0-30.3-49.4,70.13,70.13,0,0,0-51,0,54.18,54.18,0,0,0-30.3,49.4V347a54.16,54.16,0,0,0-46.2,54.2,45.77,45.77,0,0,0,6.4,25.5,65.4,65.4,0,0,0-31.9,44.6h0v9.6h0a64,64,0,0,0,39.8,60.6,38.66,38.66,0,0,0,22.3,4.8h1.6A63.66,63.66,0,0,0,444,528.8h3.2V720H255.9v63.8h510V720Zm-31.9,0H590.7V688.1h31.9V720Z",
  fill: "none"
})))), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Icoontjes_data")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
  points: "768 784 396.6 784 256 784 256 240 768 240 768 784",
  fill: "none"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#f804b01f-b289-4ac0-96a9-c0d1eca9c61f)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 176.3,
  y: 202,
  width: 669.4,
  height: 661.5
}))));
export default SvgIconPark;